import Metadata from '../../requests/apa/Metadata';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import Device from '../../devices/device';
import {
  isAndroidDevice,
  isVMayorIgual,
} from '../../AAFPersistenceManager/helpers/Utils';
import Utils from '../../utils/Utils';
import settings from 'src/devices/all/settings';
import Translator from '../../requests/apa/Translator';

export const DATA_SOURCE_TYPE_API = 'api';
export const DATA_SOURCE_TYPE_DATABASE = 'database';

let enableEpgPersistance = false;
let subRegion = null;
let metaData = null;
//version de APK
const versionApk = 521;
let offset = null;
let tmpEnabled = false;

/**
 * Delay para el cambio de canal con ch up y ch down desde la miniepg persistente
 * en milisegundos, default a 1000 ms
 */
let delayChangeChannel = null;
let dataSource = null;
let delayChangeChannelDefault = 1000;
let dataSourceDefault = DATA_SOURCE_TYPE_API;

const init = function() {
  try {
    if (Device.getDevice().getPlatform() == 'ps4') {
      enableEpgPersistance = false;
      return;
    }

    if (isAndroidDevice() && !isVMayorIgual(versionApk)) {
      enableEpgPersistance = false;
      return;
    }
    metaData = Utils.getApaMetadataKey('epg_persistence','{"enable":false}');
    if(metaData && metaData.hasOwnProperty("enable")){
      tmpEnabled = metaData.enable;
    }
  } catch (e) {
    enableEpgPersistance = false;
  }
};

/**
 * Delay para el cambio de canal con ch up y ch down desde la miniepg persistente
 * en milisegundos
 *
 * Aplica en chup/down porque los demás escenarios de cambio de canal son directos, no llevan delay
 *
 */
const getDelayChangeChannel = function() {
  try {
    // Si ya está calculado, se regresa el valor
    if (delayChangeChannel !== null) return delayChangeChannel;

    // Llave se llama epg_persistence_chup_chdown_delay_ms
    const meta = Metadata.get(
      'epg_persistence_chup_chdown_delay_ms',
      '{"default":{"delay": 1000}, "argentina":{"delay":500}}'
    );

    /**
     *    , "epg_persistence_chup_chdown_delay_ms": "{\\"default\\": { \\"delay\\": 1000},\\"argentina\\": {\\"delay\\": 500} }" }
     */

    const objectMeta = JSON.parse(meta);
    var _region = DeviceStorage.getItem('region');
    const value = objectMeta[_region] ? objectMeta[_region] : objectMeta['default'];
    if (value && typeof value == 'object' && value.delay && typeof value.delay !== undefined) {
      delayChangeChannel = value.delay;
    }
  } catch (e) {
    return delayChangeChannelDefault;
  }

  if (delayChangeChannel === null) delayChangeChannel = delayChangeChannelDefault;

  return delayChangeChannel;
};

const getTemp = function() {
  return tmpEnabled;
};

const setSubRegion = function(val) {
  //Se desactiva EPG con subregiones que venga en null.
  if (!val && getTemp() && metaData.subregion && Array.isArray(metaData.subregion)) {
    enableEpgPersistance = false;
    return;
  }
  if (val && typeof val == 'string' && metaData.subregion && Array.isArray(metaData.subregion)) {
    subRegion = val;
    checkEnableAgain();
    return;
  } else {
    if (getTemp() && !metaData.subregion && !Array.isArray(metaData.subregion)) {
      enableEpgPersistance = metaData.enable;
    }
  }
};

const checkEnableAgain = function() {
  if (metaData && typeof metaData == 'object') {
    //En las stb no se ejecuta la validacion de la subregion con cierta version de apk.
    if (isAndroidDevice() && !isVMayorIgual(versionApk)) {
      return;
    }

    if (metaData.subregion && Array.isArray(metaData.subregion) && getTemp()) {
      const find = metaData.subregion.find(el => el == getSubRegion());
      if (find) {
        // SI HACE MATCH CON ALGUNA REGION
        enableEpgPersistance = true;
      }
    }
  }
};

const getSubRegion = function() {
  return subRegion;
};

const isEnabled = function() {
  return enableEpgPersistance;
};

const needsOffset = function() {
  return offset;
};

const getOffset = function() {
  return needsOffset();
};

const setOffset = function(gmt = '-3') {
  if (gmt && !isNaN(parseInt(gmt))) {
    offset = parseInt(gmt) * 60; //needs offset in minutes
  } else {
    offset = false;
  }
  console.log('[EpgPersistence] setOffset offset', offset);
};

const getDataSource = () => {
  try {
    if(settings.use_dexie){
      return DATA_SOURCE_TYPE_DATABASE;
    }

    // Si ya está calculado, se regresa el valor
    if (dataSource) return dataSource;
    const meta = Metadata.get(
      'epg_data_source',
      '{"default":{"type": "api"}}'
    );
    const objectMeta = JSON.parse(meta);
    var _region = DeviceStorage.getItem('region');
    const value = objectMeta[_region] ? objectMeta[_region] : objectMeta['default'];
    if (value && typeof value == 'object' && value.type && typeof value.type !== undefined) {
      dataSource = value.type;
    }
  } catch (e) {
    return dataSourceDefault;
  }
}

const isApiDataSource = () => {
  return getDataSource() === DATA_SOURCE_TYPE_API;
}

const isDatabaseDataSource = () => {
  return getDataSource() === DATA_SOURCE_TYPE_DATABASE;
}

const getLabelNotAvailable = () =>{
    return Translator.get('fallenEvent_epg_notAvailable_label', 'No disponible');
}

const EpgPersistence = {
  init,
  isEnabled,
  setSubRegion,
  needsOffset,
  setOffset,
  getOffset,
  getTemp,
  getDelayChangeChannel,
  getDataSource,
  isApiDataSource,
  isDatabaseDataSource,
  getLabelNotAvailable
};

export default EpgPersistence;



// WEBPACK FOOTER //
// ./src/AAF/Nepg/EpgPersistence.js